import { memo } from 'react';

import { UploadFile } from 'UIPackage/MainModule/components/UploadFile';
import { IKnmAttachmentDocument } from 'KnmPackage/KnmDocumentsModule/interfaces/IKnmAttachmentDocument';

import styles from './KnmAttachmentsList.module.scss';
import { Row } from '../../../UIPackage/FormModule/components/Row';
import { FieldBlock } from '../../../UIPackage/FormModule/components/FieldBlock';

interface IKnmAttachmentsListWithoutFormProps {
  isWatchOnly?: boolean;
  removeField: (index: number) => void;
  values: IKnmAttachmentDocument[];
}

export const KnmAttachmentsListWithoutForm = memo(
  ({ isWatchOnly, removeField, values }: IKnmAttachmentsListWithoutFormProps) => {
    const makeRemoveHandler = (index: number) => () => !isWatchOnly && removeField && removeField(index);

    return (
      <ul className={styles.AttachmentsList} style={{ width: `100%` }}>
        {values.map((attachmentFieldValue, attachmentIndex) => {
          return (
            <li className={styles.Attachment} key={`attach-${attachmentIndex}`}>
              <Row notWrap>
                <FieldBlock size="half">
                  <UploadFile
                    fileName={attachmentFieldValue?.fileName || ''}
                    fileSize={attachmentFieldValue?.fileSize}
                    progress={100}
                    onFileNameClick={undefined}
                    onRemove={!isWatchOnly ? makeRemoveHandler(attachmentIndex) : undefined}
                  />
                </FieldBlock>
              </Row>
            </li>
          );
        })}
      </ul>
    );
  },
);
